import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Price(){
    return (
        <section className="page-section" id="price">
            <div className="container-fluid">
                <div className="container">
                            <div className="priceTag text-center px-3 pt-3">
                                <div className="title">
                                <FontAwesomeIcon icon="fa fa-plane" />
                                    <h2>PRICE</h2>
                                </div>
                                <div className="price">
                                    <h5>￦7,000 / 1주일</h5>
                                </div>
                                <div className="option">
                                    <ul>
                                        <li> <i className="fa fa-check" aria-hidden="true"></i> 일주일당 7,000원씩 </li>
                                        <li> <i className="fa fa-check" aria-hidden="true"></i> 미니캐리어 추가 시 2,000원 추가 </li>
                                        <li> <i className="fa fa-check" aria-hidden="true"></i> 연체료 하루당 2,000원 </li>
                                        <li> <i className="fa fa-times" aria-hidden="true"></i> 보증금, 파손 보상금 없음 </li>
                                    </ul>
                                </div>
                            </div>
                </div>
            </div>
        </section>
    )
}

export default Price;